import { Record } from 'immutable'
import { AssignmentSourceType } from './enums'

export interface IAssignmentSource {
  readonly name: string
  readonly sourceId: string
  readonly type: AssignmentSourceType
}

const AssignmentSourceRecord = Record({
  name: '',
  sourceId: '',
  type: AssignmentSourceType.FeedItem,
})

export class AssignmentSource extends AssignmentSourceRecord
  implements IAssignmentSource {
  public static fromJS(initialState?: Partial<IAssignmentSource>) {
    return new AssignmentSource(initialState)
  }

  public readonly name: string
  public readonly sourceId: string
  public readonly type: AssignmentSourceType

  constructor(props?: Partial<AssignmentSource>) {
    props ? super(props) : super()
  }
}
